import dayjs from "dayjs";

export const dateOfBirthWithAge = (dateOfBirth?: string | null) =>
  dateOfBirth
    ? `${dayjs(dateOfBirth).format("MM/DD/YYYY")} (${dayjs().diff(
        dayjs(dateOfBirth),
        "year",
      )}y)`
    : "";
